import * as Yup from "yup";

Yup.setLocale({
  mixed: {
    required: "Campo obrigatório",
  },
  string: {
    email: "Preencha um e-mail válido",
    min: "Mínimo de ${min} caracteres",
    max: "Máximo de ${max} caracteres",
  },
  number: {
    min: "Deve ser maior ou igual a ${min}",
    max: "Deve ser menor ou igual a ${max}",
  },
});

export const Schema = Yup.object().shape({
  initialData: Yup.array().of(
    Yup.object().shape({
      id_equipment_model: Yup.string().required(),
      service: Yup.string().required(),
      value: Yup.string().required(),
      quantity: Yup.number().required(),
    })
  ),
});
export default Schema;
